module.exports = __webpack_public_path__ + "0c71fd98.png";